var partnerInfo = {
    getSellerContact: function (postSid, contactGroup, catalogpartnerId, contactgroup_old) {
        let url = 'ajax/Partner/PartnerDetail/getPartnerDetails?sid=' + postSid +  '&contactGroup=' + contactGroup +'&catalogPartnerId=' + catalogpartnerId ;

        if (contactgroup_old) {
            url += "&contactGroupOld=" + contactgroup_old;
        }

        new Ext.Window({
            title: output["t_kontaktdaten_des_lieferanten"],
            width: 500,
            height: 600,
            layout: 'fit',
            items: [{
                xtype: "component",
                autoEl: {
                    tag: "iframe",
                    src: url
                }
            }]
        }).show();
    }
}